
import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef, signal, WritableSignal } from '@angular/core';
import { IconComponent } from '@libs/components/icons';

@Component({
  selector: 'ui-file-drop-zone',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './file-drop-zone.component.html',
  styleUrls: ['./file-drop-zone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'button',
    tabindex: '0',
    'aria-label': 'Dateien per Drag & Drop ablegen',
    '[class.is-dragging]': 'isDragging()',
    '[class.has-error]': 'hasError()',
    '(dragenter)': 'onDragEnter($event)',
    '(dragover)': 'onDragOver($event)',
    '(dragleave)': 'onDragLeave($event)',
    '(drop)': 'onDrop($event)',
  },
})
export class FileDropZoneComponent {
  public readonly multiple: InputSignal<boolean> = input<boolean>(false);
  public readonly hasError: InputSignal<boolean> = input<boolean>(false);
  public readonly filesDropped: OutputEmitterRef<FileList> = output<FileList>();

  public readonly isDragging: WritableSignal<boolean> = signal(false);

  public onDragEnter(event: DragEvent): void {
    if (!this.shouldHandleEvent(event)) {
      return;
    }

    event.preventDefault();
    this.isDragging.set(true);
  }

  public onDragOver(event: DragEvent): void {
    if (!this.shouldHandleEvent(event)) {
      return;
    }

    event.preventDefault();
    this.isDragging.set(true);

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.dataTransfer!.dropEffect = 'copy';
  }

  public onDragLeave(event: DragEvent): void {
    if (!this.shouldHandleEvent(event)) {
      return;
    }

    event.preventDefault();
    this.isDragging.set(false);
  }

  public onDrop(event: DragEvent): void {
    if (!this.shouldHandleEvent(event)) {
      return;
    }

    event.preventDefault();

    this.isDragging.set(false);

    if (event.dataTransfer?.files.length) {
      this.filesDropped.emit(event.dataTransfer.files);
    }
  }

  private shouldHandleEvent(event: DragEvent): boolean {
    return this.isFileDragEvent(event) && this.isUploadAreaTargetEvent(event);
  }

  private isFileDragEvent(event: DragEvent): boolean {
    return Boolean(event.dataTransfer?.types?.includes('Files'));
  }

  private isUploadAreaTargetEvent(event: DragEvent): boolean {
    return event.target === event.currentTarget;
  }
}
